import Backbone from 'backbone';
import $ from 'jquery';

let ContactGroup = Backbone.Model.extend({
    addToSelection(){
        return $.post(`/names-filter/${this.options.filter}/groups/${this.get('id')}/?format=json`, {
            selected: 'true'
        });
    },
    constructor(attrs, options){
        this.options = options;
        Backbone.Model.apply(this, arguments);
    },
    url(){
        return `/names-filter/${this.options.filter}/groups/`;
    }
});

export default ContactGroup;



// WEBPACK FOOTER //
// ./base/models/contactgroup.js